import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutLogosTitleLarge = {
  factory: EElement({
    id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1bb',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('ece2476c-6e0f-bbd2-10e1-12385a2f683d')]),
      children: EList([
        EElement({
          id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1bc',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1bd',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('3499c874-c154-fc32-7d63-3d006d050b7a'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1be',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Clients section'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1bf',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('adc9cbe4-704d-afe2-cb03-373d55ed8dad'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1c0',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.ariseHealthLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('Arise Health logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307a828d8e1988c895345"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('58bc7735-8995-65f1-a2f1-625e3a691cf6'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1c1',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.thePaakLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('The Paak logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307a828d8e1988c895343"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('58bc7735-8995-65f1-a2f1-625e3a691cf6'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1c2',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.oeLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('OE logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307a828d8e1988c895354"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('58bc7735-8995-65f1-a2f1-625e3a691cf6'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1c3',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.twentyLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('2020INC logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307a828d8e1988c895350"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('58bc7735-8995-65f1-a2f1-625e3a691cf6'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'e94b08c6-48a8-0d40-4a42-7e8e95e0c1c4',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.ephicientLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('Ephicient logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307a828d8e1988c89534f"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('58bc7735-8995-65f1-a2f1-625e3a691cf6'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'ece2476c-6e0f-bbd2-10e1-12385a2f683d',
      type: 'class',
      name: 'Logos Title Large',
      comb: '',
      styleLess:
        'position: relative; padding-top: 60px; padding-right: 30px; padding-bottom: 60px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '3499c874-c154-fc32-7d63-3d006d050b7a',
      type: 'class',
      name: 'Clients Title',
      comb: '',
      styleLess: 'font-size: 24px; line-height: 32px; text-align: center;',
      children: [],
      variants: {medium: {styleLess: 'margin-bottom: 32px;'}},
    },
    {
      _id: 'adc9cbe4-704d-afe2-cb03-373d55ed8dad',
      type: 'class',
      name: 'Clients Wrapper',
      comb: '',
      styleLess:
        'display: flex; max-width: 750px; margin-top: 40px; margin-right: auto; margin-left: auto; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        small: {
          styleLess:
            'margin-bottom: -20px; justify-content: space-around; flex-wrap: wrap;',
        },
      },
    },
    {
      _id: '58bc7735-8995-65f1-a2f1-625e3a691cf6',
      type: 'class',
      name: 'Clients Image',
      comb: '',
      styleLess: '',
      children: [],
      variants: {
        small: {
          styleLess:
            'margin-right: 20px; margin-bottom: 30px; margin-left: 20px;',
        },
        tiny: {styleLess: 'margin-right: 10px; margin-left: 10px;'},
      },
    },
  ],
} as const;
